var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRandomForestOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 3.5L5.5 7.5",
    stroke: "#272D55",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 10.5L1.5 12.5",
    stroke: "#272D55",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7998 10.25L11.7998 12.25",
    stroke: "#272D55",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 10.25L8.25 12.25",
    stroke: "#272D55",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5498 10L18.5498 12",
    stroke: "#272D55",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 3.5L14.5 7.5",
    stroke: "#272D55",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4C11.1046 4 12 3.10457 12 2C12 0.89543 11.1046 0 10 0C8.89543 0 8 0.89543 8 2C8 3.10457 8.89543 4 10 4Z",
    fill: "#AECDFC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.5C10.8284 3.5 11.5 2.82843 11.5 2C11.5 1.17157 10.8284 0.5 10 0.5C9.17157 0.5 8.5 1.17157 8.5 2C8.5 2.82843 9.17157 3.5 10 3.5Z",
    stroke: "#AECDFC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5 11C6.10457 11 7 10.1046 7 9C7 7.89543 6.10457 7 5 7C3.89543 7 3 7.89543 3 9C3 10.1046 3.89543 11 5 11Z",
    fill: "#AECDFC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.5C5.82843 10.5 6.5 9.82843 6.5 9C6.5 8.17157 5.82843 7.5 5 7.5C4.17157 7.5 3.5 8.17157 3.5 9C3.5 9.82843 4.17157 10.5 5 10.5Z",
    stroke: "#AECDFC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2998 10.75C16.4044 10.75 17.2998 9.85457 17.2998 8.75C17.2998 7.64543 16.4044 6.75 15.2998 6.75C14.1952 6.75 13.2998 7.64543 13.2998 8.75C13.2998 9.85457 14.1952 10.75 15.2998 10.75Z",
    fill: "#AECDFC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2998 10.25C16.1282 10.25 16.7998 9.57843 16.7998 8.75C16.7998 7.92157 16.1282 7.25 15.2998 7.25C14.4714 7.25 13.7998 7.92157 13.7998 8.75C13.7998 9.57843 14.4714 10.25 15.2998 10.25Z",
    stroke: "#AECDFC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1 14C1.55228 14 2 13.5523 2 13C2 12.4477 1.55228 12 1 12C0.447715 12 0 12.4477 0 13C0 13.5523 0.447715 14 1 14Z",
    fill: "#AECDFC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1 13.5C1.27614 13.5 1.5 13.2761 1.5 13C1.5 12.7239 1.27614 12.5 1 12.5C0.723858 12.5 0.5 12.7239 0.5 13C0.5 13.2761 0.723858 13.5 1 13.5Z",
    stroke: "#AECDFC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2998 13.75C11.8521 13.75 12.2998 13.3023 12.2998 12.75C12.2998 12.1977 11.8521 11.75 11.2998 11.75C10.7475 11.75 10.2998 12.1977 10.2998 12.75C10.2998 13.3023 10.7475 13.75 11.2998 13.75Z",
    fill: "#AECDFC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2998 13.25C11.5759 13.25 11.7998 13.0261 11.7998 12.75C11.7998 12.4739 11.5759 12.25 11.2998 12.25C11.0237 12.25 10.7998 12.4739 10.7998 12.75C10.7998 13.0261 11.0237 13.25 11.2998 13.25Z",
    stroke: "#AECDFC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 13.75C9.30228 13.75 9.75 13.3023 9.75 12.75C9.75 12.1977 9.30228 11.75 8.75 11.75C8.19772 11.75 7.75 12.1977 7.75 12.75C7.75 13.3023 8.19772 13.75 8.75 13.75Z",
    fill: "#AECDFC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 13.25C9.02614 13.25 9.25 13.0261 9.25 12.75C9.25 12.4739 9.02614 12.25 8.75 12.25C8.47386 12.25 8.25 12.4739 8.25 12.75C8.25 13.0261 8.47386 13.25 8.75 13.25Z",
    stroke: "#AECDFC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0498 13.5C19.6021 13.5 20.0498 13.0523 20.0498 12.5C20.0498 11.9477 19.6021 11.5 19.0498 11.5C18.4975 11.5 18.0498 11.9477 18.0498 12.5C18.0498 13.0523 18.4975 13.5 19.0498 13.5Z",
    fill: "#AECDFC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0498 13C19.3259 13 19.5498 12.7761 19.5498 12.5C19.5498 12.2239 19.3259 12 19.0498 12C18.7737 12 18.5498 12.2239 18.5498 12.5C18.5498 12.7761 18.7737 13 19.0498 13Z",
    stroke: "#AECDFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRandomForestOperationIcon);
export default __webpack_public_path__ + "static/media/RandomForestOperationIcon.bb926879c621094256e04b0683dc2381.svg";
export { ForwardRef as ReactComponent };